export const priceLineConstants = {
  PRICELINE_ORDERS_REQUEST: "PRICELINE_ORDERS_REQUEST",
  PRICELINE_ORDERS_SUCCESS: "PRICELINE_ORDERS_SUCCESS",
  PRICELINE_ORDERS_FAILURE: "PRICELINE_ORDERS_FAILURE",

  PRICELINE_STATUSES_REQUEST: "PRICELINE_STATUSES_REQUEST",
  PRICELINE_STATUSES_SUCCESS: "PRICELINE_STATUSES_SUCCESS",
  PRICELINE_STATUSES_FAILURE: "PRICELINE_STATUSES_FAILURE",

  PRICELINE_ORDER_DETAILS_REQUEST: "PRICELINE_ORDER_DETAILS_REQUEST",
  PRICELINE_ORDER_DETAILS_SUCCESS: "PRICELINE_ORDER_DETAILS_SUCCESS",
  PRICELINE_ORDER_DETAILS_FAILURE: "PRICELINE_ORDER_DETAILS_FAILURE",

  PRICELINE_ORDERS_SEARCH_REQUEST: "PRICELINE_ORDERS_SEARCH_REQUEST",
  PRICELINE_ORDERS_SEARCH_SUCCESS: "PRICELINE_ORDERS_SEARCH_SUCCESS",
  PRICELINE_ORDERS_SEARCH_FAILURE: "PRICELINE_ORDERS_SEARCH_FAILURE",
};
